import { sanitizeProductName } from './sanitizeProductName';
import { ProductNameProp } from './types';

type GetReleaseNotesForProductProps = ProductNameProp;

/**
 * Does a search for "Release Notes" for the given product.
 */
export const getReleaseNotesForProduct = ({ productName }: GetReleaseNotesForProductProps) => {
  const sanitizedProductName = sanitizeProductName({ productName });
  return `https://help.tanium.com/search?labelkey=tanium_${sanitizedProductName}&labelkey=release_notes`;
};
